"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var Bannier = /** @class */ (function (_super) {
    __extends(Bannier, _super);
    function Bannier($view) {
        var _this = _super.call(this, $view) || this;
        _this.initListener();
        return _this;
    }
    Bannier.prototype.initListener = function () {
        var _this = this;
        $(function () {
            if (!localStorage.getItem('bannierHidden')) {
                _this.$view.removeClass('d-none');
                _this.$view.slideDown();
            }
        });
        this.$view.find('button').on('click', function (e) {
            $(e.target).parents('.alert').slideUp();
            localStorage.setItem('bannierHidden', '1');
        });
    };
    return Bannier;
}(BaseComponent_1.default));
exports.default = Bannier;
